<template>
  <article class="choose-article">
    <Tabs>
      <tab name="Mes repas" :selected="true" class="first-meals-choose">
        <div class="header">
          <input
            type="text"
            placeholder="Rechercher un plat, un ingrédient..."
            id="my-meals-search"
            ref="mealSearch"
            v-model="search"
            @input="onSearchChange()"
            @keyup.esc="resetSearch()"
          />
          <!-- Quand on crée un repas, ça le choisit auto -->
          <AddMealButton :isChooseView="true" @click="onChoose" />
          <!-- Default Meals -->
          <div class="default-meals">
            <button
              class="default-meal"
              v-for="(defaultMeal, index) in defaultMeals"
              :key="index"
              @click="onChooseDefault(defaultMeal)"
              v-tooltip.bottom="{
                content: defaultMeal.subtitle || '',
                classes: ['tooltip-small'],
              }"
            >
              {{ defaultMeal.title }}
            </button>
          </div>
          <!-- Affichage de tous les meals -->
          <SwitchButton
            class="show-all-workspaces"
            v-model="showAllWorkspaces"
            text="Afficher tous les espaces"
            :textBefore="false"
          />
        </div>
        <div class="meals-container">
          <div>
            <MealList
              v-if="myMeals !== null"
              :meals="myMeals"
              :clickable="true"
              :updatable="false"
              :emptyMsg="$t('meals.error.empty-meal-list')"
              @click="onChoose"
            />
          </div>
          <div class="long-time-meals" v-if="longTimeMeals.length">
            <p>{{ $t('meals.choose.long-time-meals.title') }}</p>
            <MealList
              v-if="longTimeMeals !== null"
              :meals="longTimeMeals"
              :clickable="true"
              :updatable="false"
              @click="onChoose"
            />
          </div>
        </div>
      </tab>
      <tab name="Tendances">
        <h1>Tendances</h1>
      </tab>
      <tab name="De saison">
        <h1>De saison</h1>
      </tab>
      <tab name="Nouveautés">
        <h1>Nouveautés</h1>
      </tab>
    </Tabs>
  </article>
</template>

<script>
import Tab from '../Tabs/Tab.vue';
import Tabs from '../Tabs/Tabs.vue';
import MealList from './MealList.vue';
import AddMealButton from '../Form/AddMealButton.vue';
import SwitchButton from '../Form/SwitchButton.vue';

import * as fb from '../../firebase';

import mealsService from '../../services/meals.service';
import plannedMealsService from '../../services/plannedMeals.service';

export default {
  components: {
    Tabs,
    Tab,
    MealList,
    AddMealButton,
    SwitchButton,
  },
  props: {
    day: { required: true },
    mealTime: { required: true },
    plannedMealId: { default: null },
    nbItems: { default: 0 },
  },
  data() {
    return {
      unsub: [],
      longTimeMealsMem: [],
      longTimeMeals: [],
      myMealsMem: [],
      myMeals: [],
      search: '',
      defaultMeals: [],
      showAllWorkspaces: true,
    };
  },
  mounted() {
    this.getMyMeals();
    this.getLongTimeMeals();
    this.getDefaultMeals();
  },
  methods: {
    onChoose(meal) {
      if (this.plannedMealId === null) {
        // Create
        const data = {
          creatorId: fb.auth.currentUser.uid,
          workspace: this.currentWorkspaceRef,
          date: this.day.clone().startOf('day').toDate(),
          mealTime: this.mealTime,
          meal,
          createdOn: new Date(),
          order: this.nbItems,
        };
        plannedMealsService.addPlannedMeal(data);
      } else {
        // Update planned meal
        const data = {
          updatedOn: new Date(),
          meal,
        };
        plannedMealsService.updatePlannedMeal(this.plannedMealId, data);
      }
      this.$emit('close');
    },
    // Default meals en haut
    onChooseDefault(meal) {
      // on transforme en repas normal
      const plannedMeal = {
        ingredients: [],
        title: meal.title,
        isDefaultMeal: true,
      };
      this.onChoose(plannedMeal);
    },

    unsubAll() {
      // Unsub all
      this.unsub.forEach((unsub) => unsub());
    },

    // Search input
    onSearchChange() {
      // Si vide, on gagne du temps
      if (this.search === '') {
        this.myMeals = this.myMealsMem;
        this.longTimeMeals = this.longTimeMealsMem;
        return;
      }
      // Sinon on calcule
      const simplifyStr = (str) => {
        // en minuscule, sans accents
        if (str) {
          return str
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        }
        return '';
      };
      const searchVal = simplifyStr(this.search);
      // Fonction de filtre
      const filter = (meal) => {
        // Si le titre contient le texte
        const isTitle = simplifyStr(meal.title).includes(searchVal);
        // Ou un des ingrédients
        const subIngredients = false;
        meal.ingredients
          .map((ing) => ing.title)
          .filter((ingredient) => simplifyStr(ingredient).includes(searchVal));
        const isIngredient = subIngredients.length > 0;
        return isTitle || isIngredient;
      };
      this.myMeals = this.myMealsMem.filter(filter);
      this.longTimeMeals = this.longTimeMealsMem.filter(filter);
    },
    resetSearch() {
      this.search = '';
      this.onSearchChange();
    },

    /**
     * @description Meals with snapshot
     */
    getMyMeals() {
      this.unsubAll();
      this.myMealsMem = [];
      this.myMeals = [];
      const snapshot = mealsService
        .getMyMealsSnapshot(this.showAllWorkspaces, 10000)
        .onSnapshot((snap) => {
          snap.forEach((doc) => {
            if (doc.exists) {
              const meal = doc.data();
              meal.id = doc.id;
              this.myMealsMem.push(meal);
            }
          });
          // Apply filter
          this.onSearchChange();
        });
      this.unsub.push(snapshot);
    },
    getLongTimeMeals() {
      // Clone this.day pour ne pas transformer la var
      mealsService.getLongTimeMeals(15, this.day.clone()).then((meals) => {
        this.longTimeMeals = [];
        meals.forEach((meal) => {
          if (meal.exists) {
            const mealData = meal.data();
            mealData.id = meal.id;
            this.longTimeMealsMem.push(mealData);
          }
        });
        // Apply filter
        this.onSearchChange();
      });
    },

    // Get default meals from db
    getDefaultMeals() {
      mealsService.getDefaultMeals().then((defaultMeals) => {
        // On map pour être sûr de pas avoir des undefined
        this.defaultMeals = [];
        defaultMeals.forEach((defMeal) => {
          if (defMeal.exists) {
            this.defaultMeals.push(defMeal.data());
          }
        });
      });
    },
  },
  watch: {
    showAllWorkspaces() {
      this.getMyMeals();
    },
  },
};
</script>

<style lang="scss" scoped src="./ChooseMeal.scss"></style>
